export default function Testimonial() {
  const testimonial = {
    quote: "Collaborating with InovaBioTech on the design of our medical research laboratory equipment was an outstanding experience. Their team demonstrated exceptional expertise in both the physical engineering of the instrument and the seamless software integration that drives it. The result is a precision device that has significantly elevated our research capabilities.",
    author: "Dr. Robert Williams",
    title: "Laboratory Director, Global Research Institute",
    image: "https://public.readdy.ai/ai/img_res/b703b32aa59af49b5bb4ffddab52d6e3.jpg"
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden bg-[#1565C0] aspect-[4/5]">
              <img
                src={testimonial.image}
                alt={testimonial.author}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="mb-6">
              <span className="text-xs font-medium text-[#6B7280] uppercase tracking-wider">
                (CLIENT REFERENCE — INOVABIOTECH)
              </span>
            </div>
            <h2 className="text-5xl font-semibold text-[#002B5C] mb-2">
              Trusted by Leading Research Institutions
            </h2>
            <h3 className="text-5xl font-semibold text-[#FFC107] mb-14">
              Worldwide
            </h3>
            <blockquote className="mb-8">
              <p className="text-lg text-[#374151] leading-relaxed mb-8">
                "{testimonial.quote}"
              </p>
              <footer className="text-lg font-bold text-[#002B5C]">
                — {testimonial.author}, {testimonial.title}
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
